<ng-container *ngIf="loading; else elseBlock">
  <app-spinner></app-spinner>
</ng-container>
<ng-template #elseBlock>
  <ng-content></ng-content>
</ng-template>
